import ForgotPassword from '../components/forgot_password/ForgotPassword';


function ForgotPasswordPage() {
    return (
        <div className="container">

            <ForgotPassword />
        </div>
    );
}

export default ForgotPasswordPage;
